export const API_BASE_URL =
  (typeof process !== 'undefined' && process.env.MEMORAIZ_API_URL) ||
  'https://hdbnp00qlg.execute-api.eu-central-1.amazonaws.com';
